import PropTypes from 'prop-types';

export const AppliedFilterPropType = PropTypes.shape({
  criterionArgumentValue: PropTypes.any,
  criterionMeta: PropTypes.any,
  criterionOperatorValue: PropTypes.string,
  filterById: PropTypes.string,
  filterValue: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
});

/**
 * @typedef {object} AppliedFilterPropType
 * @property {any} criterionArgumentValue
 * @property {any} criterionMeta
 * @property {string} criterionOperatorValue
 * @property {string} filterById
 * @property {string} filterValue
 * @property {string} id
 * @property {string} type
 */
